module.exports = __webpack_public_path__ + "img/icon_sec6_02.dc83904c.png";